import moment from 'moment';
import { setTimezoneWithoutAlteringTime } from 'utils/utility_functions/timezone';

/**
 * Get page limit from user context based on module type
 * @param {boolean} isLeadSpecific - Whether it's from leads module
 * @param {boolean} isFromCaseSpecificModule - Whether it's from case module
 * @param {Object} userContext - User context object
 * @returns {number|undefined} - Page limit or undefined
 */
export const getPageLimit = (isLeadSpecific, isFromCaseSpecificModule, userContext) => {
  if (isLeadSpecific && userContext) {
    return userContext?.firmDetails?.pagination_preference?.leads?.billings?.payment_history;
  } else if (isFromCaseSpecificModule && userContext) {
    return userContext?.firmDetails?.pagination_preference?.case?.billings?.payment_history;
  } else if (userContext) {
    return userContext?.firmDetails?.pagination_preference?.billings?.payment_history;
  }
};

/**
 * Get file path for pagination preferences
 * @param {boolean} isLeadSpecific - Whether it's from leads module
 * @param {boolean} isFromCaseSpecificModule - Whether it's from case module
 * @returns {Object} - Path object with module, subModule, and listName
 */
export const getFilePathForPagination = (isLeadSpecific, isFromCaseSpecificModule) => {
  if (isLeadSpecific) {
    return { module: 'leads', subModule: 'billings', listName: 'payment_history' };
  } else if (isFromCaseSpecificModule) {
    return { module: 'case', subModule: 'billings', listName: 'payment_history' };
  } else {
    return { module: 'billings', subModule: '', listName: 'payment_history' };
  }
};

/**
 * Extract date range from date array and convert to timezone format
 * @param {Array} dateArray - Array of dates [startDate, endDate]
 * @param {string} timezone - User timezone
 * @returns {Object} - Object with payment_date_lower and payment_date_upper
 */
export const pickExtractedDate = (dateArray, timezone) => {
  return {
    payment_date_lower: dateArray?.[0] ? setTimezoneWithoutAlteringTime(moment(dateArray[0]).startOf('day'), timezone) : '',
    payment_date_upper: dateArray?.[0]
      ? setTimezoneWithoutAlteringTime(moment(dateArray[1] ? dateArray[1] : dateArray[0]).endOf('day'), timezone)
      : '',
  };
};
